import { Contact, PatientInfo } from 'apps/wrapper/src/services/api-client/contact-api';
import { AppointmentAvailability } from 'apps/wrapper/src/services/appointment/types/appointment-availability';
import { AppointmentRequestDetails } from 'apps/wrapper/src/services/appointment/types/appointment-request-details';
import { createContext } from 'react';

export interface RequestDetailsViewContextProps {
  isLoading: boolean;
  contact: Contact | undefined;
  isEditable: boolean;
  patientInfo: PatientInfo | undefined;
  requestDetails: AppointmentRequestDetails;
  appointmentAvailabilities: AppointmentAvailability[] | undefined;
}

export const RequestDetailsViewContext = createContext<RequestDetailsViewContextProps>(null!);
